import { render } from "./CustomerManagement.vue?vue&type=template&id=18a9422a"
import script from "./CustomerManagement.vue?vue&type=script&lang=js"
export * from "./CustomerManagement.vue?vue&type=script&lang=js"
script.render = render

export default script